import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// Inject watermark removal CSS immediately to prevent flash
const style = document.createElement('style');
style.textContent = `
  /* Hide elements with watermark-related classes */
  [class*="watermark"], [class*="branding"], [class*="powered"], 
  [class*="logo"], [class*="footer"], [class*="attribution"], 
  [class*="credit"] {
    display: none !important;
    visibility: hidden !important;
    opacity: 0 !important;
  }
  
  /* Hide links to ElevenLabs */
  a[href*="elevenlabs"], a[href*="11labs"] {
    display: none !important;
    visibility: hidden !important;
  }
  
  /* Hide positioned elements that might be watermarks */
  [style*="position: absolute"][style*="bottom"], 
  [style*="position: fixed"][style*="bottom"] {
    display: none !important;
  }
  
  /* Hide small font elements (common for attribution) */
  [style*="font-size: 10px"], [style*="font-size: 12px"] {
    display: none !important;
  }
  
  /* Hide low opacity elements (common for subtle watermarks) */
  [style*="opacity: 0.7"], [style*="opacity: 0.8"] {
    display: none !important;
  }
  
  /* Hide gray/grey text elements */
  [style*="color: gray"], [style*="color: grey"], 
  [style*="color: #999"], [style*="color: #666"] {
    display: none !important;
  }
  
  /* Hide text content that contains watermark text */
  *:contains("Powered by"), *:contains("ElevenLabs"), 
  *:contains("elevenlabs"), *:contains("AI") {
    display: none !important;
  }
  
  /* Hide watermark elements within shadow DOM */
  elevenlabs-convai *[class*="watermark"],
  elevenlabs-convai *[class*="branding"],
  elevenlabs-convai *[class*="powered"],
  elevenlabs-convai *[class*="logo"],
  elevenlabs-convai *[class*="footer"],
  elevenlabs-convai *[class*="attribution"],
  elevenlabs-convai *[class*="credit"] {
    display: none !important;
    visibility: hidden !important;
  }
`;
document.head.appendChild(style);

createRoot(document.getElementById("root")!).render(<App />);
